import { createModule } from '../utils/factories';
import { resources } from '@/services/resources';
import indexManager from '../components/indexManager';

export default createModule({
  path: 'oorChainElement',
  resourceProfile: resources.oorChainElement,
  components: [indexManager],
  setup({ components }) {
    return {
      module: {},
      protected: {
        ...components.$indexManager.public,
      },
    };
  },
});
